import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './app.vue'
import axios from 'axios'
import router from "@/router"
import extendUtilsToVue from '@/utils/extendUtilsToVue'
import { Err401,startLoading,loadComplete } from '@/utils/util'
import '@vuepic/vue-datepicker/dist/main.css'
import  checkUpdateInterval from '@/utils/auto-update'
import { checkToken, Session, setToken, accessTokenKey, refreshAccessTokenKey, clearAccessTokens, getToken, getRefreshToken, decryptJWT, getJWTDate, tansParams, getTenantId } from '@/utils/AxiosToken'
const myapp = createApp(App);
// app.component('VueDatePicker', VueDatePicker);
// myapp.component('Field', Field);
// myapp.component('Form', Form);
// myapp.component('ErrorMessage', ErrorMessage);


myapp.config.warnHandler = () => null   //去掉控制台警告信息
extendUtilsToVue(myapp)
axios.interceptors.response.use(
    response => {
       // console.log(response.status)
        loadComplete();
        if (response.data.status == 401) {
            clearAccessTokens();
        }
        
        if (response.status === 200) {
            var accessToken = response.headers[accessTokenKey];
            var refreshAccessToken = response.headers[refreshAccessTokenKey];
           
            if (accessToken === 'invalid_token') {
                Err401();
                return Promise.reject(response);
            }
            // 判断是否存在刷新 token，如果存在则存储在本地
            else if (refreshAccessToken && accessToken && accessToken !== 'invalid_token') {
              
                setToken(accessToken, refreshAccessToken);
            }
            if (response.data.status == 500) {
                // return Promise.reject(response);
                return Promise.reject(response.data);
            } else if (response.data.status == 401) {
              
                Err401();
                return Promise.reject(response.data);
            } else if (response.data.status == 601) {
                //並發
                // console.error(response.data);
                return Promise.reject(response.data);
            }
            //  if (!response.data.data)
            return Promise.resolve(response.data);
            //  return Promise.resolve(response.data.data);
        } else {
            return Promise.reject(response.data);
        }
    },
    error => {
        
        loadComplete();
        if (error.response && error.response.status) {

            switch (error.response.status) {
                case 401:
                    //clearAccessTokens();
                    Err401();
                    
                    break;
                case 403:
                    clearAccessTokens();
                    // console.log(error.response);
                    // alert("CCc");
                    window.location.href = process.env.NODE_ENV === "production" ? "/" : "/";
                    //Err401();
                    break;

                //  delCookie("authuser");
                //  window.location.href = "../account/Logout";
                //    window.location.href = loginUrl;
                //break;
                case 500:
                    //  alert(error.response.statusText);
                    console.log("500",error.response);

                    break;

                case 404:
                    console.log("404", error.response);
                    break;
                default:
                    console.error(error.response);


            }
            return Promise.reject(error.response);
        } else {
            console.error(error);
            return Promise.reject(error);
        }
    });
axios.interceptors.request.use(function (config) {
 
    const accessToken = getToken();
   
    if (accessToken) {
       
        // 将 token 添加到请求报文头中
        config.headers['Authorization'] = `Bearer ${accessToken}`;
        // 判断 accessToken 是否过期
        let jwt = decryptJWT(accessToken);
        let exp = getJWTDate(Number(jwt.exp));

        if (new Date() >= exp) {
            // 获取刷新 token
            const refreshAccessToken = getRefreshToken();// Local.get(refreshAccessTokenKey);
            if (refreshAccessToken) {
                config.headers['X-Authorization'] = `Bearer ${refreshAccessToken}`;
            }
        }

        if (config.method?.toLowerCase() === 'get' && config.data) {
            let url = config.url + '?' + tansParams(config.data);
            url = url.slice(0, -1);
            config.data = {};
            config.url = url;
            //alert(url);
           // console.warn(url)
        }
    }


    if (config.url.toLowerCase().indexOf('account/login') == -1) {
        //config.headers = {
        //    "authorization": "Bearer " + sessionStorage.getItem("authuser"),
        //    'Content-Type': 'application/json'
        //};
        startLoading();
    }
    //if (config.url.toLowerCase().indexOf('refreshtoken') == -1) {
    //    sessionStorage.setItem("actdate", new Date());
    //}
    //console.log(config)
    return config
})
myapp.use(router)
myapp.use(createPinia())
router.isReady().then(() => {
    myapp.mount('#app');
    Session.remove("xi");
    if (process.env.NODE_ENV === "production") {
        checkUpdateInterval(() => {
            alert("the portal has been updated, please refresh.");
            window.location.href = process.env.NODE_ENV === "production" ? "/" : "/";
        });
    }
})
//window.addEventListener('storage', function (e) {
//    localStorage.setItem(e.key, e.oldValue)
//});
//window.addEventListener('storage', function (e) {
//    this.sessionStorage.setItem(e.key, e.oldValue)
//});

//自定义防抖全局组件
myapp.directive('debounce', {
    mounted(el, binding) {
      // 至少需要回调函数以及监听事件类型
      if (typeof binding.value.fn !== 'function' || !binding.value.event) return;
      let delay = 200; // 默认延迟时间
      el.timer = null;
      el.handler = function() {
        if (el.timer) {
          clearTimeout(el.timer);
          el.timer = null;
        };
        el.timer = setTimeout(() => {
          binding.value.fn.apply(this, arguments)
          el.timer = null;
        }, binding.value.delay || delay);
      }
      el.addEventListener(binding.value.event, el.handler);
    },
    // 元素卸载前清理定时器并且移除监听事件
    beforeMount(el, binding) {
      if (el.timer) {
        clearTimeout(el.timer);
        el.timer = null;
      }
      el.removeEventListener(binding.value.event, el.handler)
    }
  })